import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FeaapplicationService } from '../../shared/services/feaapplication.service';

@Component({
  selector: 'app-fea-application',
  templateUrl: './fea-application.component.html',
  styleUrls: ['./fea-application.component.css']
})
export class FeaApplicationComponent implements OnInit {
  applicationForm: FormGroup;
  formSubmitted = false;
  submitting = false;
  submissionError: string | null = null;

  constructor(private formBuilder: FormBuilder, private applicationService: FeaapplicationService) {
    this.applicationForm = this.createForm();
  }

  ngOnInit(): void {
  }

  /**
   * Create the application form with all fields and validators
   */
  private createForm(): FormGroup {
    return this.formBuilder.group({
      // Personal Information
      fullName: ['', [Validators.required, Validators.minLength(2)]],
      dateOfBirth: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      city: ['', [Validators.required, Validators.minLength(2)]],

      // Educational Background
      education: ['', Validators.required],
      fieldOfStudy: ['', [Validators.required, Validators.minLength(2)]],

      // Motivation & Interests
      whyInterested: ['', [Validators.required, Validators.minLength(10)]],
      technicalExperience: ['', Validators.required],
      trackInterest: ['', Validators.required],
      problemSolve: ['', [Validators.required, Validators.minLength(10)]],

      // Commitment & Circumstances
      employmentStatus: ['', Validators.required],
      fullCommitment: ['', Validators.required],
      challenges: ['', [Validators.required, Validators.minLength(10)]],
      overcomeChallenges: ['', [Validators.required, Validators.minLength(10)]],

      // Discipline & Agreement
      disciplineWilling: ['', Validators.required],
      whySelect: ['', [Validators.required, Validators.minLength(10)]],
      commitmentAgreement: ['', Validators.required],
      confirmInfo: [false, Validators.requiredTrue]
    });
  }

  /**
   * Check if a field is invalid and touched
   */
  isFieldInvalid(fieldName: string): boolean {
    const field = this.applicationForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  /**
   * Submit the application form
   */
  submitApplication(): void {
    if (this.applicationForm.valid) {
      const formData = this.applicationForm.value;
      this.submitting = true;
      this.submissionError = null;

      this.applicationService.submitApplication(formData)
        .then(id => {
          console.log('Application submitted, id:', id);
          this.formSubmitted = true;
          // Clear form fields but keep the success message visible briefly
          this.resetForm(true);
          // Auto-hide success alert sooner (10 seconds)
          setTimeout(() => { this.formSubmitted = false; }, 10000);
        })
        .catch(err => {
          console.error('Error submitting application', err);
          this.submissionError = 'Failed to submit application. Please try again later.';
        })
        .finally(() => {
          this.submitting = false;
        });
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.applicationForm.controls).forEach(key => {
        this.applicationForm.get(key)?.markAsTouched();
      });
      console.error('Form is invalid');
    }
  }

  /**
   * Reset the application form
   */
  resetForm(keepMessage = false): void {
    this.applicationForm.reset();
    if (!keepMessage) {
      this.formSubmitted = false;
    }
    this.submissionError = null;
    this.submitting = false;
  }
}
